<template>
  <section class="viewsrhqy_EntryAuth space-y-2 p-4">
    <viewTitle title="业务管理 / 车辆业务授权管理" :showReturn="false" />
    <div class="flex justify-between items-center">
      <span class="space-x-10">
        <span class="text-red-600">未授权：{{ countMap['wait_auth_num'] }}</span>
        <span class="text-yellow-600">已授权待呼叫：{{ countMap['wait_calling_num'] }}</span>
      </span>
      <el-button v-has="['c-auth-record-auth']" @click="onAuthorize()" type="primary" size="small"
        >授权</el-button
      >
    </div>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="预约单号">
        <el-input
          clearable
          v-model="queryParam.code"
          placeholder="请输入预约单号"
          class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="车辆业务类型">
        <el-input
          clearable
          v-model="queryParam.car_business_name"
          placeholder="请输入车辆业务类型名称"
          class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="车辆类型">
        <el-select
          class="w-60"
          clearable
          v-model="queryParam.vehicle_type"
          placeholder="请选择车辆类型"
        >
          <el-option
            v-for="car in vehicleTypes"
            :key="car.id"
            :label="car.name"
            :value="car.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预约业务">
        <el-input
          clearable
          v-model="queryParam.business_name"
          placeholder="请输入预约业务名称"
          class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="物料类型">
        <el-input
          clearable
          v-model="queryParam.chip_type"
          placeholder="请输入物料类型"
          class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input
          clearable
          v-model="queryParam.license_plate"
          placeholder="请输入车牌号"
          class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item label="登记时间">
        <el-date-picker
          class="!w-96"
          style="margin-bottom: 10px;"
          v-model="timeRange"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="refreshData" size="small"
        >刷新数据
      </el-button>
    </el-form>
    <c-table
      class="mt-4"
      :isIndex="true"
      isSelection
      :selection.sync="rowKeySelection"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="booking_id"
      @loadPage="loadData"
    >
      <template slot="report_time" slot-scope="{ row }">
        {{ row.report_time | timeFormat }}
      </template>
      <template slot="business_list" slot-scope="{ row }">
        <div v-for="business in row.business_list">{{ business.name }}</div>
      </template>
      <template slot="action" slot-scope="{ row }">
        <div class="space-x-4">
          <c-link
            @click="onAuthorize(row)"
            v-has="['c-auth-record-auth']"
            type="success"
            label="授权"
          ></c-link>
          <c-link @click="onViewBooking(row)" type="primary" label="查看"></c-link>
        </div>
      </template>
    </c-table>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import { mapGetters } from "vuex";
export default {
  props: [],

  data() {
    return {
      columns: [
        { label: "预约业务名称", prop: "business_name" },
        { label: "车辆业务类型", prop: "business_list" },
        {
          label: "车辆类型",
          prop: "vehicle_type",
          formatData: row => {
            const type = this.vehicleTypes.find(
              type => type.id === row.vehicle_type
            );
            return type ? type.name : "--";
          }
        },
        { label: "订单号", prop: "order_code" },
        { label: "物料类型", prop: "chip_type" },
        { label: "车辆号", prop: "license_plate" },
        {
          label: "预约状态",
          prop: "state",
          formatData: row => {
            return this.businessState[row.state] || "--";
          }
        },
        {
          label: "登记时间",
          prop: "report_time"
        },
        { label: "操作", prop: "action" }
      ],
      fetchDataEvent: params =>
        this.$common.http({
          url: "/api/queue/admin/query_auth_booking",
          data: params
        }),
        countMap: {},
        loadCallBack: this.getCount
    }
  },

  computed: {
    ...mapGetters(["businessState", "vehicleTypes"])
  },

  components: {},

  mixins: [initListMinxin, mixinTableLyout],

  beforeCreate() {},

  created() {
  },

  beforeMount() {},

  mounted() {},

  activated() {},

  deactivated() {},

  methods: {
    onViewBooking(row) {
      const { business_list } = row;
      let type = "";
      business_list.map((item) => {
        type = item.type;
      });
      if (type === 11) {
        this.$router.push({
          path: "/rhqy/service/AppointDeliveryRecord/Detail/" + row.booking_info_id
        })
      }
      if (type === 12) {
        this.$router.push({
          path: "/rhqy/service/AppointPickup/Detail/" + row.booking_info_id
        })
      }
    },
    onAuthorize(row) {
      let selection = [];
      if (row) {
        selection = [row.booking_id];
      } else {
        selection = this.rowKeySelection;
      }
      if (selection.length === 0) {
        this.$message({ message: "请选择要授权的记录！", type: "warning" });
        return;
      }
      this.$confirm(
        `确认授权已选中的${
          !row ? selection.length + "条" : ""
        }记录？确认后即可进行呼叫进厂操作！`,
        "授权确认"
      )
        .then(_ => {
          this.$common
            .http({
              url: "/api/queue/admin/auth_booking",
              data: { booking_ids: selection.join(",") }
            })
            .then(() => {
              this.$message({ message: "授权成功！", type: "success" });
              this.refreshData();
            });
        })
        .catch(_ => {});
    },
    async getCount() {
      const res = await this.$common.http({
        url: "/api/queue/admin/count_auth_booking"
      });
      this.countMap = res.data.data;
    }
  }
};
</script>
<style lang="less" scoped>
@import "./assets/css/common";
.viewsrhqy_EntryAuth {
  .el-form-item {
    margin-bottom: 10px !important;
  }
}
</style>
<style lang="less">
.viewsrhqy_EntryAuth {
}
</style>
